import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from './Select';
import {
  inputPropTypes,
  metaPropTypes,
  inputDefaultProps,
  metaDefaultProps,
} from '../../forms/input/InputPropTypes';
import { DEFAULT_QUERY_GET_ALL } from '../../../../config/queries';
import { optionsPropTypes } from './SelectPropTypes';
import {
  clearCabinCrewContractTypes,
  getCabinCrewContractTypes,
} from '../../../../actions';

const CabinCrewContractTypeSelect = ({
  dispatchGetCabinCrewContractTypes,
  dispatchClearCabinCrewContractTypes,
  isMulti,
  input,
  options,
  meta,
  isLoading,
  cleanWhenUnmount,
}) => {
  useLayoutEffect(() => {
    dispatchGetCabinCrewContractTypes(DEFAULT_QUERY_GET_ALL);

    return () => {
      if (cleanWhenUnmount) {
        dispatchClearCabinCrewContractTypes();
      }
    };
  }, []);

  return (
    <Select
      options={options}
      isLoading={isLoading}
      isMulti={isMulti}
      input={input}
      meta={meta}
    />
  );
};

CabinCrewContractTypeSelect.propTypes = {
  dispatchGetCabinCrewContractTypes: PropTypes.func.isRequired,
  dispatchClearCabinCrewContractTypes: PropTypes.func.isRequired,
  isMulti: PropTypes.bool,
  input: inputPropTypes,
  options: optionsPropTypes,
  meta: metaPropTypes,
  isLoading: PropTypes.bool,
  cleanWhenUnmount: PropTypes.bool,
};

CabinCrewContractTypeSelect.defaultProps = {
  isLoading: false,
  input: inputDefaultProps,
  meta: metaDefaultProps,
  isMulti: false,
  options: [],
  cleanWhenUnmount: true,
};

const mapStateToProps = ({ TrafficUnit }) => ({
  options: TrafficUnit.CabinCrewContractType.getIn([
    'all',
    'content',
    'content',
  ]).map((status) => ({
    value: status.id,
    label: status.name,
  })),
  loading: TrafficUnit.CabinCrewContractType.getIn(['all', 'loading']),
});

const mapDispatchToprops = {
  dispatchGetCabinCrewContractTypes: getCabinCrewContractTypes,
  dispatchClearCabinCrewContractTypes: clearCabinCrewContractTypes,
};

export default connect(
  mapStateToProps,
  mapDispatchToprops,
)(CabinCrewContractTypeSelect);
